/**
 * talk·point — EU-Energielabel-Overlay
 * ---------------------------------------------------------------------------
 * Huelle: snippets/tp-eec-dialog.liquid (einmal pro Seite)
 * Auslöser: [data-tp-eec-open] aus snippets/tp-pdp-energy.liquid
 * Plan: docs/migration/eec-label-overlay-plan.md
 *
 * Delegiert an document, nicht an die einzelnen Auslöser: auf Collection-Seiten
 * (Phase 2) haengen sonst 48 Listener an 48 Karten, und nachgeladene Karten
 * (Variantenwechsel, Paginierung) blieben tot.
 *
 * Das Labelbild wird NIE beim Seitenaufbau geladen. Zwei Stufen:
 *   pointerenter/focus → new Image() waermt vor (erkennbare Absicht)
 *   click              → src setzen und oeffnen
 * Auf Touch uebernimmt pointerenter denselben Vorlauf wenige Millisekunden vor
 * dem Klick, weil der Zeigerkontakt dem Klick vorausgeht.
 *
 * Bewusst import-frei und ohne Abhaengigkeit zu den Horizon-Komponenten (Muster
 * tp-addon-modal): das Overlay soll auch dort laufen, wo kein dialog.js geladen ist.
 *
 * KEIN Scroll-Lock in JS. Der erste Versuch setzte html[scroll-lock] beim Oeffnen und
 * nahm es im 'close'-Ereignis wieder weg — auf der PDP kam das Ereignis nicht an, und
 * die Seite blieb nach dem Schliessen gesperrt (gemessen: Escape → scroll-lock blieb).
 * Jetzt haengt die Sperre per :has() direkt am [open]-Zustand des Dialogs
 * (siehe stylesheet-Block in snippets/tp-eec-dialog.liquid). Kein Zustand, der lecken
 * kann; ohne :has()-Unterstuetzung faellt nur die Hintergrundsperre weg.
 */
(function () {
  if (window.__tpEecDialogInit) return;
  window.__tpEecDialogInit = true;

  var dialog = document.getElementById('tp-eec-dialog');
  // Kein <dialog>-Support: die Auslöser bleiben normale Links auf das Labelbild.
  if (!dialog || typeof dialog.showModal !== 'function') return;

  var img = dialog.querySelector('[data-tp-eec-img]');
  var clsEl = dialog.querySelector('[data-tp-eec-class]');
  var fullEl = dialog.querySelector('[data-tp-eec-full]');
  var ficheEl = dialog.querySelector('[data-tp-eec-fiche]');
  if (!img || !fullEl) return;

  var warmed = Object.create(null);

  function triggerFrom(node) {
    return node && node.closest ? node.closest('[data-tp-eec-open]') : null;
  }

  function warm(event) {
    var trigger = triggerFrom(event.target);
    if (!trigger || !trigger.href || warmed[trigger.href]) return;
    warmed[trigger.href] = true;
    new Image().src = trigger.href;
  }

  function open(event) {
    // Modifier- und Mittelklick gehoeren dem Browser: neuer Tab statt Overlay.
    if (event.defaultPrevented || event.button > 0) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    var trigger = triggerFrom(event.target);
    if (!trigger || !trigger.href) return;
    event.preventDefault();

    var cls = trigger.getAttribute('data-eec-class') || '';
    var scale = trigger.getAttribute('data-eec-scale') || '';
    var width = trigger.getAttribute('data-eec-w');
    var height = trigger.getAttribute('data-eec-h');
    var fiche = trigger.getAttribute('data-eec-fiche') || '';

    /* Masse VOR dem src setzen: das Bild bekommt sein Seitenverhaeltnis, bevor
       es da ist — der Dialog geht in Endgroesse auf und springt nicht nach. */
    if (width && height) {
      img.setAttribute('width', width);
      img.setAttribute('height', height);
    } else {
      img.removeAttribute('width');
      img.removeAttribute('height');
    }

    img.alt =
      'EU-Energielabel' +
      (cls ? ': Energieeffizienzklasse ' + cls : '') +
      (scale ? ' auf der Skala ' + scale : '') +
      '.';
    if (img.getAttribute('src') !== trigger.href) img.setAttribute('src', trigger.href);

    if (clsEl) {
      clsEl.textContent = cls ? 'Klasse ' + cls + (scale ? ' · Skala ' + scale : '') : '';
      clsEl.hidden = !cls;
    }

    fullEl.href = trigger.href;

    if (ficheEl) {
      if (fiche) {
        ficheEl.href = fiche;
        ficheEl.hidden = false;
      } else {
        ficheEl.removeAttribute('href');
        ficheEl.hidden = true;
      }
    }

    try {
      dialog.showModal();
    } catch (error) {
      /* showModal wirft nur, wenn der Dialog schon offen ist. Der Klick darf
         trotzdem nicht ins Leere laufen — dann eben der Weg ohne Overlay. */
      console.error('EEC-Overlay konnte nicht geoeffnet werden', error);
      window.open(trigger.href, '_blank', 'noopener');
    }
  }

  document.addEventListener('click', open);
  /* pointerover statt pointerenter: enter steigt nicht auf und muesste in der
     Capture-Phase abgefangen werden — dann laeuft der Handler bei jeder
     Mausbewegung einmal je Vorfahr statt einmal je Ziel. */
  document.addEventListener('pointerover', warm);
  document.addEventListener('focusin', warm);

  dialog.addEventListener('click', function (event) {
    // Klick auf den Hintergrund (das <dialog> selbst, nicht sein Inhalt) schliesst.
    if (event.target === dialog || event.target.closest('[data-tp-eec-close]')) {
      dialog.close();
    }
  });
})();
